import React from 'react'

export default function ClassProgressTableField(props) {
  const { fieldTitle, scale, isBenchmarkOnly } = props;
  return (
    <div className="classProgressTableField">
      <div className="classProgressTableFieldTitle">{fieldTitle}</div>
      <div className="classProgressTableFieldHeaders">
        <div className="classProgressTableFieldHeaderName">{scale === "ESRI" ? "EHFWI" : scale}</div>
        <div className="classProgressTableFieldHeaderName">PR</div>
        {!isBenchmarkOnly && <div className="classProgressTableFieldHeaderName">Latest</div>}
      </div>
    </div>
  )
}
